import { styled as muiStyled, Paper } from '@mui/material'

export const TeacherPayoutFilterDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
  @media print{
    width: 100%!important;
    height: 100vh!important;
    border-radius: 0px;
  }
    max-height: 100vh!important;
    max-width: 100vw!important;
    margin:0px!important; 
    min-height: 550px;
    width: 550px;
`,
)

export const TeacherPayoutReportsFiltersContainer = muiStyled('div')(
  ({ theme }) => `
  margin-top: 12px;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  flex-direction: column;
  justify-content: flex-start;
  @media (min-width: 768px) {
  flex-direction: row;
  justify-content: space-between;
  }
`,
)
